/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalizedValue,
    LocalizedValueFromJSON,
    LocalizedValueFromJSONTyped,
    LocalizedValueToJSON,
    Metadata,
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './';

/**
 * Waste usage object
 * @export
 * @interface Usage
 */
export interface Usage {
    /**
     * 
     * @type {string}
     * @memberof Usage
     */
    readonly id?: string;
    /**
     * Localized usage names
     * @type {Array<LocalizedValue>}
     * @memberof Usage
     */
    localizedNames: Array<LocalizedValue>;
    /**
     * 
     * @type {Metadata}
     * @memberof Usage
     */
    metadata: Metadata;
}

export function UsageFromJSON(json: any): Usage {
    return UsageFromJSONTyped(json, false);
}

export function UsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Usage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'localizedNames': ((json['localizedNames'] as Array<any>).map(LocalizedValueFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function UsageToJSON(value?: Usage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localizedNames': ((value.localizedNames as Array<any>).map(LocalizedValueToJSON)),
        'metadata': MetadataToJSON(value.metadata),
    };
}


